// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

export type xVariantProductsType = {
    isLoading: boolean;
    productsInfo: { [erp: string]: ProductInfo };
};

const initialState: xVariantProductsType = {
    isLoading: false,
    productsInfo: {},
};

const xVariantProducts = createTypedReducerWithImmer(initialState, {
    "VariantProducts/AddProductsInfo": (draft: Draft<xVariantProductsType>, actions: { productsInfo: any }) => {
        draft.productsInfo = { ...draft.productsInfo, ...actions.productsInfo };
    },
});

(reducers as any).xVariantProducts = xVariantProducts;

export type xVariantProductsState = {
    xVariantProducts: xVariantProductsType;
} & ApplicationState;

type xVariantProductsReducers = {
    xVariantProducts: typeof xVariantProducts;
};

export type VariantProductsActions =
    | Parameters<xVariantProductsReducers[keyof xVariantProductsReducers]>[1]
    | AnyAction;
